import { booleanAttribute, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tile-button',
  templateUrl: './tile-button.component.html',
  styleUrls: ['./tile-button.component.scss']
})
export class TileButtonComponent  implements OnInit {

  @Input() dictionaryKey: string;

  @Input() iconCSS: string;

  @Input({ transform: booleanAttribute }) fitHeight = false;

  constructor(
  ) {

  }

  ngOnInit(): void { }

}
